import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function PublicRoute() {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const handleReload = () => {
  window.location.reload();
};

  // Wait until auth state is stable
  if (!isAuthenticated) {
    return <Outlet />;
  }

if (user?.role === 'SUPER_ADMIN' || user?.role === 'ADMIN') {
  // Use window.location to force a full browser refresh to the root
  window.location.href = "/";
  
  // Return null or a loader while the browser begins the reload
  return null; 
}

  return <Navigate to="/unauthorized" replace />;
}
